import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { 
    PanelBody, 
    TextControl, 
    ToggleControl, 
    SelectControl, 
    BoxControl,
    TabPanel
} from '@wordpress/components';

// Import custom components
import Typography from '../../components/Typography';
import FlatColorPicker from '../../components/FlatColorPicker';
import VisibilityControl from '../../components/VisibilityControl';
import IconPicker from '../../components/IconPicker';

// Import typography helper
import { getSpacingStyles, getTypographyStyles } from '../../utils/styles';

registerBlockType('kanews/button', {
    title: __('Buton', 'kanews'),
    icon: 'button',
    category: 'kanews',
    attributes: {
        text: {
            type: 'string',
            default: __('Buton Metni', 'kanews')
        },
        url: {
            type: 'string',
            default: '#'
        },
        type: {
            type: 'string',
            default: 'primary'
        },
        size: {
            type: 'string',
            default: 'default'
        },
        isFullWidth: {
            type: 'boolean',
            default: false
        },
        target: {
            type: 'boolean',
            default: false
        },
        icon: {
            type: 'string',
            default: ''
        },
        iconSpacing: {
            type: 'string',
            default: '8px'
        },
        margin: {
            type: 'object',
            default: {}
        },
        padding: {
            type: 'object',
            default: {}
        },
        backgroundColor: {
            type: 'string',
            default: ''
        },
        textColor: {
            type: 'string',
            default: ''
        },
        typography: {
            type: 'object',
            default: {
                fontSize: '',
                fontFamily: '',
                fontWeight: '',
                lineHeight: '',
                letterSpacing: ''
            }
        },
        visibility: {
            type: 'object',
            default: {
                desktop: false,
                tablet: false,
                mobile: false
            }
        },
    },
    edit: ({ attributes, setAttributes }) => {
        const blockProps = useBlockProps();
        const { 
            text, 
            url, 
            type, 
            size, 
            isFullWidth, 
            target, 
            icon,
            iconSpacing,
            margin,
            padding,
            backgroundColor,
            textColor,
            typography,
            visibility
        } = attributes;

        const visibilityClasses = [
            visibility?.desktop ? 'hidden-desktop' : '',
            visibility?.tablet ? 'hidden-tablet' : '',
            visibility?.mobile ? 'hidden-mobile' : ''
        ].filter(Boolean);

        const wrapperProps = {
            className: ['kanews-btn-wrapper', 'kanews-block-margin', ...visibilityClasses].filter(Boolean).join(' '),

            style: {
                ...getSpacingStyles(margin, 'margin')
            }
        };




        const tabs = [
            {
                name: 'content',
                title: __('İçerik', 'kanews'),
                className: 'content-tab'
            },
            {
                name: 'design',
                title: __('Tasarım', 'kanews'),
                className: 'design-tab'
            },
            {
                name: 'visibility',
                title: __('Görünürlük', 'kanews'),
                className: 'visibility-tab'
            }
        ];

        return (
            <>
                <InspectorControls>
                    <TabPanel
                        className="kanews-tab-panel components-base-control"
                        tabs={tabs}
                    >
                        {(tab) => {
                            return (
                                <>
                                    {tab.name === 'content' && (
                                        <PanelBody>
                                            <TextControl
                                                label={__('Buton Metni', 'kanews')}
                                                value={text}
                                                onChange={(value) => setAttributes({ text: value })}
                                            />
                                            <TextControl
                                                label={__('URL', 'kanews')}
                                                value={url}
                                                onChange={(value) => setAttributes({ url: value })}
                                            />
                                            <SelectControl
                                                label={__('Tür', 'kanews')}
                                                value={type}
                                                options={[
                                                    { label: __('Birincil', 'kanews'), value: 'primary' },
                                                    { label: __('Kenar Çizgili', 'kanews'), value: 'o' }
                                                ]}
                                                onChange={(value) => setAttributes({ type: value })}
                                            />
                                            <SelectControl
                                                label={__('Boyut', 'kanews')}
                                                value={size}
                                                options={[
                                                    { label: __('Varsayılan', 'kanews'), value: 'default' },
                                                    { label: __('Küçük', 'kanews'), value: 'sm' },
                                                ]}
                                                onChange={(value) => setAttributes({ size: value })}
                                            />
                                            <ToggleControl
                                                label={__('Tam Genişlik', 'kanews')}
                                                checked={isFullWidth}
                                                onChange={(value) => setAttributes({ isFullWidth: value })}
                                            />
                                            <ToggleControl
                                                label={__('Yeni sekmede aç', 'kanews')}
                                                checked={target}
                                                onChange={(value) => setAttributes({ target: value })}
                                            />
                                            <IconPicker
                                                value={icon}
                                                onChange={(value) => setAttributes({ icon: value })}
                                                label={__('İkon Seç', 'kanews')}
                                            />
                                        </PanelBody>
                                    )}
                                    {tab.name === 'design' && (
                                        <PanelBody>
                                            <Typography
                                                value={typography}
                                                showColor={false}
                                                showTextAlign={false}
                                                showLineHeight={false}
                                                onChange={(value) => setAttributes({ typography: value })}
                                            />
                                            <FlatColorPicker
                                                label={__('Birincil Renk', 'kanews')}
                                                value={backgroundColor || ''}
                                                onChange={(value) => setAttributes({ backgroundColor: value })}
                                            />
                                            <FlatColorPicker
                                                label={__('Metin Rengi', 'kanews')}
                                                value={textColor || ''}
                                                onChange={(value) => setAttributes({ textColor: value })}
                                            />
                                            {icon && (
                                                <TextControl
                                                    type="number"
                                                    label={__('İkon Aralığı', 'kanews')}
                                                    value={parseInt(iconSpacing)}
                                                    onChange={(value) => setAttributes({ iconSpacing: value + 'px' })}
                                                    help={__('İkon ile metin arasındaki boşluk (px)', 'kanews')}
                                                />
                                            )}
                                            <BoxControl
                                                label={__('Margin', 'kanews')}
                                                values={margin}
                                                onChange={(value) => setAttributes({ margin: value })}
                                                units={[
                                                    { value: 'px', label: 'px' },
                                                    { value: '%', label: '%' },
                                                    { value: 'em', label: 'em' },
                                                    { value: 'rem', label: 'rem' }
                                                ]}
                                            />
                                        </PanelBody>
                                    )}
                                    {tab.name === 'visibility' && (
                                        <PanelBody>
                                            <VisibilityControl
                                                value={visibility}
                                                onChange={(value) => setAttributes({ visibility: value })}
                                            />
                                        </PanelBody>
                                    )}
                                </>
                            );
                        }}
                    </TabPanel>
                </InspectorControls>
                <div {...blockProps}>
                    <div {...wrapperProps}>
                        <div
                            className={`kanews-btn kanews-btn-${type} kanews-btn-${size} ${isFullWidth ? 'kanews-btn-block' : ''}`}
                            style={{
                                ...getTypographyStyles(typography),
                                ...getSpacingStyles(padding, 'padding')
                            }}
                        >
                            {icon && <i className={`fa ${icon}`} style={{ marginRight: iconSpacing }}></i>}
                            {text}
                        </div>
                    </div>
                </div>
            </>
        );
    },
    save: ({ attributes }) => {
        const { 
            text, 
            url, 
            type, 
            size, 
            isFullWidth, 
            target, 
            icon,
            iconSpacing,
            margin,
            padding,
            backgroundColor,
            textColor,
            typography,
            visibility
        } = attributes;

        const visibilityClasses = [
            visibility?.desktop ? 'hidden-desktop' : '',
            visibility?.tablet ? 'hidden-tablet' : '',
            visibility?.mobile ? 'hidden-mobile' : ''
        ].filter(Boolean);

        const wrapperProps = {
            className: ['kanews-btn-wrapper', 'kanews-block-margin', ...visibilityClasses].filter(Boolean).join(' '),

            style: {
                ...getSpacingStyles(margin, 'margin')
            }
        };

        return (
            <div {...wrapperProps}>
                <a
                    href={url}
                    className={`kanews-btn kanews-btn-${type} kanews-btn-${size} ${isFullWidth ? 'kanews-btn-block' : ''}`}
                    style={{
                        ...getTypographyStyles(typography),
                        ...getSpacingStyles(padding, 'padding')
                    }}
                    target={target ? '_blank' : undefined}
                    rel={target ? 'noopener noreferrer' : undefined}
                >
                    {icon && <i className={`fa ${icon}`} style={{ marginRight: iconSpacing }}></i>}
                    {text}
                </a>
            </div>
        );
    }
}); 